module.exports = __webpack_public_path__ + "img/15.d861f718.jpg";